import { DayOfWeekSchedule } from "../enums/day-of-week-schedule";
import { DocumentData } from "@angular/fire/firestore";
import { ProductScheduleSettings } from "../models/product.schedule";
import { ScheduleType } from "../enums";
import * as firebase from "firebase";
import * as moment from "moment";
import { Timeframe } from "../../models/timeframe";

export class ProductScheduleSettingsBuilder {
  public type: ScheduleType;
  public dow?: DayOfWeekSchedule;
  public blackout: string[];
  public availability: Timeframe;
  constructor() {
    this.dow = null;
    this.blackout = [];
    this.availability = new Timeframe(null, null);
  }

  load(data: DocumentData) {
    this.type = data.type;
    this.dow = data.dow ? new DayOfWeekSchedule(data.dow) : null;
    this.blackout = data.blackout ? data.blackout : [];
    this.availability = data.availability
      ? this.buildTimeFrame(data.availability.begin, data.availability.end)
      : null;
  }

  buildTimeFrame(begin: any | null, end: any | null): Timeframe {
    return new Timeframe(
        begin ? new firebase.firestore.Timestamp(begin._seconds, 0) : null,
        end ? new firebase.firestore.Timestamp(end._seconds, 0) : null,
    );
  }

  edit(schedule: ProductScheduleSettings) {
    this.type = schedule.type;
    this.dow = schedule.dow;
    this.blackout = schedule.blackout;
    this.availability = schedule.availability;
  }

  setType(type: ScheduleType) {
    this.type = type;
    return this;
  }
  setDaysOfWeek(dow: DayOfWeekSchedule) {
    this.dow = this.type == ScheduleType.DayOfWeek ? dow : null;
    return this;
  }
  setBlackout(blackout: string[]) {
    this.blackout = this.type == ScheduleType.CustomDays ? [] : blackout;
    return this;
  }
  setAvailability(from: string, to: string, timezone: string) {
    let f =
      from == null
        ? null
        : firebase.firestore.Timestamp.fromDate(
            moment(from, "YYYY-MM-DD")
              .tz(timezone, true)
              .toDate()
          );
    let t =
      to == null
        ? null
        : firebase.firestore.Timestamp.fromDate(
            moment(to, "YYYY-MM-DD")
              .tz(timezone, true)
              .toDate()
          );
    this.availability = new Timeframe(f, t);
    return this;
  }
}
